// @ts-strict-ignore
import React from 'react';
import { GestureResponderEvent, TouchableWithoutFeedback } from 'react-native';
import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import analytics from '../../../../modules/analytics';

import { BodyText } from '../../../ui';
import { BasicSearchIcon } from '../../../ui/Icons';
import { clickable } from '../../../../styles';

const SearchPopoverTrigger = ({
  onOpen,
  text = 'Service, stylist or salon',
  showHeaderSearchBar = false,
  useAlternativeStyle = false,
}) => {
  const handleOpenPress = React.useCallback((event: GestureResponderEvent) => {
    event.preventDefault();
    analytics.track('client_home_discovery_search_clicked', {
      component: 'home_discovery_search',
    });

    if (showHeaderSearchBar) {
      analytics.track('click', {
        component: 'header_search_bar',
      });
    }
    onOpen();
  }, [onOpen]);

  return (
    <TouchableWithoutFeedback onPress={handleOpenPress}>
      <Inline
        padding={useAlternativeStyle ? 0 : 8}
        paddingLeft={useAlternativeStyle ? 8 : undefined}
        color={BrandColor.WhiteWash}
        style={clickable}
        alignItems={useAlternativeStyle ? 'center' : undefined}
        justifyContent={useAlternativeStyle ? 'space-between' : undefined}
      >
        {!useAlternativeStyle && (
          <Box paddingRight={4} borderRadius={100}>
            <BasicSearchIcon
              width={20}
              height={20}
            />
          </Box>
        )}
        <BodyText color={BrandColor.Silver}>{text}</BodyText>
        {useAlternativeStyle && (
          <Box
            padding={useAlternativeStyle ? 8 : undefined}
            paddingRight={useAlternativeStyle ? undefined : 4}
            borderRadius={100}
            color={BrandColor.BackInBlack}
          >
            <BasicSearchIcon
              width={20}
              height={20}
              color={BrandColor.WhiteWash}
            />
          </Box>
        )}
      </Inline>
    </TouchableWithoutFeedback>
  );
};

export default SearchPopoverTrigger;
